/*
 * @Subscription:
 * @Author: Luke Z
 * @Date: 2021-06-10 12:26:19
 * @LastEditors: Teemo Ding
 * @LastEditTime: 2022-02-28 14:01:17
 * @FilePath: /unifyxp-v2-store-portal/src/constrains/DraggableModules/PreloadComponent/SubscriptionPreloading/index.tsx
 */
import React from 'react';
import { Select } from 'src/components/Antd';
import { useQueryLanguageListContentEditor } from 'src/constrains/SalesChannelMultiLanguageSelect';
import { getCustomerInfoFields } from 'src/request/common';
import {
  //getContentButtonThemes,
  getContentContentPages,
  getContentLayerMetaInfo,
} from 'src/request/salesChannel/content';
import { getTCs } from 'src/request/salesChannel/legal';
import { EnumSalesChannelMultiLanguage } from 'src/types/server/params';
//import { getContentLayerMetaInfo } from 'src/request/salesChannel/content';
import { useRequest } from 'ahooks';
import { get } from 'lodash';

const ContentModuleGroupPreloading = (props) => {
  const { value, onChange } = props;
  const {
    options, // exemptUuid
  } = React.useContext(ContentModuleGroupPreloadingContext);
  const { inUsePages, previousPages, pendingPages } = options;
  const disabledOptions = [...previousPages, ...pendingPages].find(
    (i) => i.uuid === value,
  );
  const _options = [];
  if (disabledOptions) {
    _options.push(disabledOptions);
  }
  _options.push(...inUsePages);

  return (
    <Select
      value={value}
      onChange={onChange}
      optionsList={_options.map((i) => {
        const { name, uuid } = i;

        return { label: name, value: uuid };
      })}
    />
  );
};

const ContentModuleGroupPreloadingContext = React.createContext({
  options: {
    inUsePages: [],
    previousPages: [],
    pendingPages: [],
  },
  tc: [],
  fields: [],
  buttons: [],
  animations: [],
  hoverAnimations: [],
});
const ContentModuleGroupPreloadingWrapper = (props) => {
  const { contentUuid, exemptUuid, children, saleChannelUuid } = props;

  // const [options, setOptions] = React.useState({
  //   inUsePages: [],
  //   previousPages: [],
  //   pendingPages: [],
  // });
  const [tc, setTC] = React.useState([]);
  // const [fields, setFields] = React.useState([]);
  // const [buttons, setButtons] = React.useState([]);
  // const [animations, setEntranceAnimations] = React.useState([]);
  // const [hoverAnimations, setHoverAnimations] = React.useState([]);
  //const [loaded, setLoaded] = React.useState(false);
  const currentLanguage = useQueryLanguageListContentEditor();
  // const termsAndConditions = getTCs(saleChannelUuid, {
  //   [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
  // });

  const { data, loading } = useRequest(() => {
    // const termsAndConditions = getTCs(saleChannelUuid, {
    //   [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    // });
    const contentPages = getContentContentPages(contentUuid, {});
    const customerFields = getCustomerInfoFields(saleChannelUuid);
    const contentMetaInfo = getContentLayerMetaInfo(contentUuid);
    const req = Promise.all([
      //termsAndConditions, // contentPages,
      customerFields,
      contentPages,
      contentMetaInfo,
    ]);
    return req;
  });

  const _customerFields: any = get(data, '0') || [];

  const _contentPages = get(data, '1');
  const _contentMetaInfo = get(data, '2') || {};

  const buttonThemes = get(_contentMetaInfo, 'buttonThemes') || [];
  const entranceAnimations = get(_contentMetaInfo, 'entranceAnimations') || [];
  const hoverAnimations = get(_contentMetaInfo, 'hoverAnimations') || [];
  // const { buttonThemes, entranceAnimations, hoverAnimations } =
  //   _contentMetaInfo;
  // const { buttonThemes, entranceAnimations, hoverAnimations } = data[3];
  // const { inUsePages, previousPages, pendingPages } = contentPages;
  const inUsePages = get(_contentPages, 'inUsePages') || [];
  const previousPages = get(_contentPages, 'previousPages') || [];
  const pendingPages = get(_contentPages, 'pendingPages') || [];
  const options = {
    inUsePages: inUsePages.filter((i) => i.uuid !== exemptUuid),
    previousPages: previousPages.filter((i) => i.uuid !== exemptUuid),
    pendingPages: pendingPages.filter((i) => i.uuid !== exemptUuid),
  };

  React.useEffect(() => {
    console.log('useEffect');
    // const contentButtonThemes = getContentButtonThemes(contentUuid);
    // const contentAnimation = getSalesChannelContentAnimation(contentUuid);
    // Promise.all([
    //   termsAndConditions, // contentPages,
    //   customerFields,
    //   contentPages,
    //   contentMetaInfo,
    // ]).then((res: any) => {
    //   console.log('meta,,,', res[3]);
    //   setLoaded(true);
    //   const { buttonThemes, entranceAnimations, hoverAnimations } = res[3];
    //   setHoverAnimations(hoverAnimations);
    //   const termsAndConditions = res[0].summaryList || [];
    //   setTC(termsAndConditions);
    //   setEntranceAnimations(entranceAnimations || []);
    //   setButtons(buttonThemes || []);
    //   setFields(res[1]);
    //   const contentPages = res[2];
    // const { inUsePages, previousPages, pendingPages } = contentPages;
    // setOptions({
    //   inUsePages: inUsePages.filter((i) => i.uuid !== exemptUuid),
    //   previousPages: previousPages.filter((i) => i.uuid !== exemptUuid),
    //   pendingPages: pendingPages.filter((i) => i.uuid !== exemptUuid),
    // });
    // });
  }, []);
  React.useEffect(() => {
    getTCs(saleChannelUuid, {
      [EnumSalesChannelMultiLanguage.multiLanguageInParams]: true,
    }).then((res: any) => {
      const termsAndConditions = res.summaryList || [];
      setTC(termsAndConditions);
    });
  }, [currentLanguage]);

  //console.log('animations,buttons', animations, buttons);
  return (
    <ContentModuleGroupPreloadingContext.Provider
      value={{
        options: options,
        tc: tc,
        fields: _customerFields,
        buttons: buttonThemes,
        animations: entranceAnimations,
        hoverAnimations: hoverAnimations,
      }}>
      {!loading && children}
    </ContentModuleGroupPreloadingContext.Provider>
  );
};
export {
  ContentModuleGroupPreloading,
  ContentModuleGroupPreloadingContext,
  ContentModuleGroupPreloadingWrapper,
};
